import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';

import AdviceSection from '../common/AdviceSection';
import Methodology from '../common/Methodology';

import SelectFilters from '../common/select-filters/SelectFilters';
import Cards from '../common/cards/Cards';
import Pagination from '../common/pagination/Pagination';

import { getOSHCountries, getOSHData } from '../../api';

// Countries Exceptions
import { oshAuthoritiesExceptions } from '../../model/countriesExceptions';

const OSHAuthorities = (props) => {
	const [countries, setCountries] = useState([]);
	const [matrixPageData, setMatrixPageData] = useState([]);
	const [pageOfItems, setPageOfItems] = useState([]);
	const [searchBarText, setSearchBarText] = useState('');
	const [isFetching, setIsFetching] = useState(false);
	const [defaultTags, setDefaultTags] = useState(false);
	const [filters, setFilters] = useState({
		countries: [],
		checks: [],
		searchBar: ''
	});
	
	// 
	const handleCallbackCountry = (countryCallback) => {
		const countryFilter = filters.countries;
		// Check if the selected country is already selected
		const countryCode = filters.countries.find((country) => country?.code == countryCallback.code)
		if (countryCallback.code != countryCode?.code) {
			// The current country is not selected, add it
			setFilters({...filters, countries: [...countryFilter, countryCallback]});
		} else {
			// The current country is in the filters, remove it
			const index = filters.countries.findIndex((country) => country?.code == countryCallback.code);
			const newCountryFilters = filters.countries;
			newCountryFilters.splice(index, 1);
			setFilters({...filters, countries: newCountryFilters});
		}
	}

	const handleCallbackInstitution = (institutionCallback) => {
		const checkFilter = filters.checks.find((data) => data.id == institutionCallback.id);
		const checks = filters.checks;


		if (!checkFilter) {
			setFilters({...filters, checks: [...checks, {...institutionCallback, check: true}]});
		} else {
			const index = filters.checks.findIndex((data) => data.id == institutionCallback.id);
			const newArray = filters.checks;
			newArray.splice(index, 1);
			setFilters({...filters, checks: newArray});
		}
	}

	// Handles callback for the search bar on filters component
	const handleCallbackSearch = (searchCallback) => {
		setFilters({...filters, searchBar: searchCallback});
	}

	//when country is selected
	const onSelectCountryTag = (countryCode) => {
		return () => {
			const countryIndex = filters.countries.findIndex((country) => country.code == countryCode);
			const newArray = filters.countries;
			newArray.splice(countryIndex, 1);
			setFilters({...filters, countries: newArray});
		}
	}

	//When institution is selected
	const onSelectInstitutionTag = (institutionId) => {
		return () => {
			const institutionIndex = filters.checks.findIndex((institution) => institution.id == institutionId);
			const newArray = filters.checks;
			newArray.splice(institutionIndex, 1);
			setFilters({...filters, checks: newArray});
		}
	}

	// Handles change of page when clicked on the next or prev
	const onChangePage = (pageOfItems) => {
		setPageOfItems(pageOfItems)
	}

	useEffect(() => {
		// Update the title for the page
		document.title = props.literals.L22002 +  " - " + props.literals.L22020 + " - " + props.literals.L363;

		setIsFetching(true);

		try {
			getOSHCountries('MATRIX_AUTHORITY', ['UK'])
			.then((res) => {
				setCountries(res.resultset);
			})


			if (!props.lockedCountry) {
				getOSHData('MATRIX_AUTHORITY')
				.then((res) => {
					// Filter the returned elements so there are no elements with empty values for all the texts
					setMatrixPageData(res.resultset.filter(item => props.literals['L'+item.text1] != "" || props.literals['L'+item.text2] != "" || props.literals['L'+item.text3] != ""))
				})
			} else {
				const exceptions = oshAuthoritiesExceptions.find((element) => props.lockedCountry == element.code);
				if (!exceptions) 
				{
					getOSHData('MATRIX_AUTHORITY', {countries: [props.lockedCountry]})
					.then((res) => {
						setMatrixPageData(res.resultset);
					});
				}
			}
		} catch (error) {
			console.log('Error fetching selector countries:', error)
		} finally {
			setIsFetching(false);
		}
	}, []);

	// If any modification happens to the filter state, it updates with the new values
	useEffect(() => {
		setIsFetching(true);
		try {
			getOSHData('MATRIX_AUTHORITY', filters)
			.then((res) => {
				// Filter the returned elements so there are no elements with empty values for all the texts
				setMatrixPageData(res.resultset.filter(item => props.literals['L'+item.text1] != "" || props.literals['L'+item.text2] != "" || props.literals['L'+item.text3] != ""));
			})
		} catch (error) {
			console.log('Error fetching data', error)
		} finally {
			setIsFetching(false);
		}
	}, [filters])

	useEffect(() => {
		if (!defaultTags && countries.length != 0 && props.lockedCountry != '')
		{
			const exceptions = oshAuthoritiesExceptions.find((element) => props.lockedCountry == element.code);
			if (!exceptions) 
			{
				const countryDefault = countries.find((country) => country.code == props.lockedCountry);
				setDefaultTags(true);
				setFilters({...filters, countries: [countryDefault]});
			} 
			else 
			{
				const countryDefault = countries.find((country) => country.code == 'AT');
				setDefaultTags(true);
				setFilters({...filters, countries: [countryDefault]});
			}
		}
	}, [defaultTags, countries, props.lockedCountry])

	return(
		<div className="osh-authority">
			<AdviceSection literals={props.literals} section={["osh-context","osh-authorities"]} methodologyData={{section: 'osh-context', subsection: 'OSH authorities', indicator: 27}}/>

			{/* FILTERS COMPONENT */}
			<section className="container">
			
				<SelectFilters 
					selectCountries={countries} 
					literals={props.literals} 
					onClickCountry={handleCallbackCountry}
					onClickInstitution={handleCallbackInstitution}
					onSearchbarClick={handleCallbackSearch}
					selectedFilters={filters}
					filterCategory={'institution'}
				/>

				<div className="container">
					<div className="selected--tags-wrapper">
						{filters && (
							<div>
								{filters.countries.map((country) => (
									country && (<span key={country.code} className="selected-tag" onClick={onSelectCountryTag(country.code)}>{country.code == 'EU27_2020' ? '' : `(${country.code})`} {country.name}</span>)
								))}
								{filters.checks.map((array) => {
									if (array.check) {
										return <span key={array.id} className="selected-tag" onClick={onSelectInstitutionTag(array.id)} > {props.literals[`L${array.literal}`]} </span>
									}
								} )}
							</div>
						)}
					</div>
					
					{/** Cards Component */}
					<div className="matrix--elements--wrapper">
						{pageOfItems.length > 0 ? (
							pageOfItems.map((data, index) => {
								const position = matrixPageData.findIndex((matrixData) => matrixData == data);
								const id = `${index}-${data.country.code}-${position}`

								return <Cards key={id} idCard={id} countryData={data} literals={props.literals} cardType={'institution'}/>
							})
						) : (<span>{props.literals.L20706}</span>)}
					</div>

					{/* PAGINATION */}
					<Pagination items={matrixPageData} onChangePage={onChangePage} />
				</div>
				<div className="modal fade" id="modalChart" tabIndex="-1" role="dialog" aria-labelledby="modalChart" aria-hidden="true">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
							<button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
							<p className="modal-title text-center"></p>
							</div>
							<div className="modal-body text-center"><img src="/img/img-not-available.png" alt="Image not available" /></div>
						</div>
					</div>
				</div>
			</section>

			<Methodology literals={props.literals} section={'OSH authorities'} />
		</div>
	)
}
OSHAuthorities.displayName = 'OSHAuthorities';

function mapDispatchToProps(state){
	const { lockedCountry, selectedByUser } = state.selectCountries;
    return { lockedCountry, selectedByUser };
}

export default connect(mapDispatchToProps)(OSHAuthorities);